// Utilities
import { defineStore } from 'pinia'

export const useKiwiFormValidationCheck = defineStore('kiwiFormValidation', {
  state: () => ({
    isValid: true,
    errorMessage: {
        // user_full_name: null,
        // country: null,
        // phone_number: null,
        // refral_code: null,
        // email: null,
        // password: null,
        // confirm_password: null,
        // storemsg: null,
    },
  }),
  getters: {

  },
  actions: {
     validPassword(password) {
        const strongPasswordRegex = /^.{6,}$/;
        const isValid = strongPasswordRegex.test(password);
        if (isValid) {
            this.isValid = true;
            this.errorMessage.password = '';
        } else {
            this.isValid = false;
            this.errorMessage.password = 'Password is too short or invalid.';
        }
    },
    validConfirmPassword(password, confirm) {
        if(password === confirm) {
            this.isValid = true;
            this.errorMessage.confirm_password = '';
        }  else  {
            this.isValid = false;
            this.errorMessage.confirm_password = 'Confirm password is not mathcing with given password.';
        }
    },
    validEmail(email) {
        const validEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isValid = validEmailRegex.test(email);
        if(isValid) {
            this.isValid = true;
            this.errorMessage.email = '';
        } 
        // else if(email === JSON.parse(localStorage.getItem('googleUser')).email) {
        //     this.isValid = false;
        //     this.errorMessage.email = 'This account is registered with Google. Please sign in using Google instead.'
        // }
        else {
            this.isValid = false;
            this.errorMessage.email = 'E-mail must be valid'
        }
        isValid === true ? this.errorMessage.email = '' : this.errorMessage.email = 'E-mail must be valid'
        // console.log(email, isValid)
    },
    storeApiValidation(error) {
        console.log('After API Error', error)
        if(error.data && error.data.errors) {
            this.errorMessage.storemsg = error.data.errors
        }else if(error.response?.data?.data){
            this.errorMessage.storemsg = error.response.data.data
        } else {
            this.errorMessage.storemsg = error.data
        }
        
    },
    clearApiValidation() {
        this.errorMessage.storemsg = {}
    }
  },

})
